import {throttle} from "./throttle";

var dynamicPage = function (wrapper) {
	var maxDelta = 500, /*  */
        endScrollTime = 200,
        clearWaitEndScroll,
        itemAllObj = [],
        itemCurInd = 0, /* индекс */
        xhr = false,
        metaEls = function(){
            var data = {};
            var head = document.querySelector('head');

            data.ogTitle = head.querySelector('meta[property="og:title"]');
            data.ogUrl = head.querySelector('meta[property="og:url"]');
            return data;
        }(),
        changeMeta = function(data){
            document.title = data.title || '';
            if(metaEls.ogTitle) metaEls.ogTitle.setAttribute('content', data.title || '');
            if(metaEls.ogUrl) metaEls.ogUrl.setAttribute('content', data.url || '');
        },
        Item = class {
	        constructor(prevItemObj){
	            if(!prevItemObj){ //первый пункт, который уже есть на странице
	                this.itemEl = wrapper.querySelector('[data-dynamicPage-item]');
                    this.url = window.location.pathname + window.location.search;
                    this.hideBlocks();
                    this.addModules();
                }
                else {
                    this.url = prevItemObj.param.next;
                    xhr = new XMLHttpRequest();
                    xhr.open("POST", this.url, true);
                    xhr.setRequestHeader("X-Request-Ajax","1");
                    xhr.onload = () => {this.onloadData()}
                    xhr.send('');
                }
            }

            onloadData(){
	            if(!xhr.responseText) return; //закончилось
                var tempBlock = document.createElement('DIV');
                var sticking = false; //возможно прилипание страницы к низу
	            tempBlock.innerHTML = xhr.responseText;
	            this.itemEl = tempBlock.firstElementChild;
	            if(wrapper.getBoundingClientRect().bottom < 0 ) sticking = true;
                this.hideBlocks();
                wrapper.appendChild(this.itemEl);
                if(sticking) window.scrollBy(0, (this.itemEl.getBoundingClientRect().top-46));
                this.reloadScripts();
                this.addModules();
                xhr = false;
            }

            hideBlocks(){ //некотрые элементы навигации остались от статичных страниц для роботов. Скрываем их.
	            var blocks = this.itemEl.querySelectorAll('[data-dynamicPage-hide]');
	            blocks.forEach(function(el){
	                el.style.display='none';
                });
            }

            reloadScripts(){ //перегружаем тег скрипт, сущ на новой странице
	            console.log('reloadScripts');
               var scripts = this.itemEl.querySelectorAll('[data-dynamicPage-script]');
                scripts.forEach(function(el){
                    var src = el.getAttribute('src');

                    if(src){
                        var script = document.createElement('script');
                        script.type = 'text/javascript';
                        script.src = src;
                        document.body.appendChild(script);
                    } else {
                        console.log('eval', el.innerHTML);
                        eval(el.innerHTML);
                    }
                });
            }

            addModules(){
                this.param = JSON.parse(this.itemEl.getAttribute('data-dynamicPage-item'));
                this.modules = APP.modules.run(this.itemEl, 'data-dynamicPage-modules');
            }
        },
        checkLoad = function(){
            if(xhr) return;
            var docHeight = document.documentElement.clientHeight;
            var delta = wrapper.getBoundingClientRect().bottom - docHeight;
            if (delta < maxDelta){
                var prevItemObj = itemAllObj[itemAllObj.length-1];
                itemAllObj.push(new Item(prevItemObj)); /* TODO */
            }
            waitEndScroll();
        },
        waitEndScroll = function(){
            if(clearWaitEndScroll) clearTimeout(clearWaitEndScroll);
            clearWaitEndScroll = setTimeout(onEndScroll, endScrollTime);
        },
        onEndScroll = function(){
            checkPage();
            clearWaitEndScroll = false;
        },
        checkPage = function(){
            var middlePage = document.documentElement.clientHeight/2;
            var curInd = false;
            var itemObj;

            //
            itemAllObj.some(function(item, ind){
                var rect = item.itemEl.getBoundingClientRect();
                if(rect.top <= middlePage && rect.bottom >= middlePage){
                    curInd = ind;
                    return true;
                }
            });
            curInd = curInd ? curInd : 0; /* для первой страницы */
            if(itemCurInd != curInd){
                //console.log('новая страница', curInd);
                itemCurInd = curInd;
                var itemObj = itemAllObj[itemCurInd];
                window.history.pushState({module:'DynamicPage', ind:curInd}, '', itemObj.url);
                changeMeta({
                    title: itemObj.param.title,
                    url: itemObj.url
                });
                sendStat(itemObj.url);
            }
        },
        sendStat = function(url){
            try{
                gtag('config', 'UA-21667993-5', {
                    'page_path': url
                });
            } catch(e){}
        },
        onPopstate = function(e){
            /*
            * урл может меняться в двух случаях:
            * при щелчке  на стрелочки вперед-назад и, напрмиер, при сизмеении хэша
            * если поменяли хэш, данные будут отсутствовать. При изменении хеша ничего не делаем
            * если нажали в браузере вперед-назад - перегружаем страницу
            */

            if(!e.state) return;

            window.removeEventListener('scroll', checkLoad);
            window.scrollTo(0,0);
            window.location.reload(true);
        },
        init = function(){
            itemAllObj.push(new Item()); /* TODO */
            throttle('scroll', checkLoad);
            throttle('resize', checkLoad);
            throttle('orientationChange', checkLoad);
            window.history.replaceState({module:'DinamicPage', ind:0}, location.href);
            window.addEventListener('popstate', onPopstate);
            checkLoad();
        };

	//
    init();
};

export {dynamicPage};